import Url from '../global/Url';

/**
 * Autenticación por sesión de servidor.
 *
 * El navegador ya no guarda al usuario ni ningún token: la identidad vive en una
 * cookie httpOnly que el servidor pone al iniciar sesión y que viaja sola en cada
 * petición. Aquí solo se conserva en memoria el token CSRF, que hace falta para
 * las operaciones de escritura.
 */
let csrf = null;

export function getCsrf() {
    return csrf;
}

export async function login(userEmail, userPassword) {
    const r = await fetch(Url.Api + 'auth/login', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ userEmail, userPassword }),
    });
    const data = await r.json();
    if (r.ok && data.header === 'OK') {
        csrf = data.csrf;
        cachearUsuario(data.usuario);
        return data.usuario;
    }
    throw new Error(data.message || 'No se pudo iniciar sesión');
}

/** ¿Hay sesión abierta? Se llama al cargar la app. */
export async function sesionActual() {
    try {
        const r = await fetch(Url.Api + 'auth/yo', { headers: { Accept: 'application/json' } });
        if (!r.ok) return null;
        const data = await r.json();
        csrf = data.csrf;
        cachearUsuario(data.usuario);
        return data.usuario;
    } catch {
        return null;
    }
}

export async function logout() {
    try {
        await fetch(Url.Api + 'auth/logout', {
            method: 'POST',
            headers: { 'X-CSRF': csrf || '' },
        });
    } finally {
        csrf = null;
        try { sessionStorage.removeItem('user'); } catch {}
    }
}

/**
 * Caché de solo presentación: el nombre para la barra lateral, etc.
 * NO es la fuente de seguridad -esa es la cookie httpOnly del servidor-; los
 * componentes existentes lo leen para mostrar datos, no para autorizar.
 */
function cachearUsuario(u) {
    try {
        sessionStorage.setItem('user', JSON.stringify({
            userId: u.id, userName: u.nombre, userEmail: u.email, tenant: u.tenant,
        }));
    } catch {}
}
